import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Configuración global del cliente de caché TanStack Query (Enterprise Standard)
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutos de frescura en memoria (elimina peticiones repetidas)
      gcTime: 1000 * 60 * 30, // 30 minutos en garbage collection
      refetchOnWindowFocus: false, // Evita refetches agresivos al cambiar pestañas
      retry: 1, // Reintento seguro ante microcortes de red
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

reportWebVitals();
